<script setup lang="ts">
import { ContentComp } from '@/components';
import { $tm } from '@/locize';
</script>

<template>
    <ContentComp class="p-2">
        <div
            class="alert alert-danger flex-column text-start"
            role="alert"
        >
            <h3 class="alert-heading">{{ $tm('notauthorized.header') }}</h3>
            <p v-html="$tm('notauthorized.body', '', true)"></p>
        </div>
    </ContentComp>
</template>
